<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Clone Creatives</modal-header>
    </div>
    <div class="form-group">
      <div class="field">
        <form-group>
          <field name="Clone Creative Name" value="" v-model="cloneCreativeName" :error="error"/>
        </form-group>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="confirm" cancelText="Cancel" confirmText="Yes"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'

export default {
  name: 'modal_clone_creative',
  mixins: [modalMixin, campaignMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean,
    creativeId: String
  },
  data: () => ({
    cloneCreativeName: '',
    error: ''
  }),
  mounted () {
  },
  computed: {},
  methods: {
    confirm () {
      if (!this.cloneCreativeName) {
        this.error = 'This value should not be blank.'
        return
      }
      this.startLoading()
      this.cloneCreative({creativeId: this.creativeId, cloneCreativeName: this.cloneCreativeName}).then(() => {
        this.addNotification('success', `Creative successfully cloned.`)
        const id = this.$route.params.id
        this.getCreatives(id).then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-clone-creative.vue